import { render, staticRenderFns } from "./MoveUnitModal.vue?vue&type=template&id=b1b57d92&scoped=true&"
import script from "./MoveUnitModal.vue?vue&type=script&lang=js&"
export * from "./MoveUnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b57d92",
  null
  
)

export default component.exports